import moveSelectionForward from './moveSelectionForward';
export default function updateBlockAttributes(editor, retain, _ref) {
  var type = _ref.type,
      data = _ref.data;

  if (type || type === null) {
    editor.setBlocks({
      type: type || 'unstyled'
    });
  }

  if (data || data === null) {
    editor.setBlocks({
      data: data || {}
    });
  }

  return moveSelectionForward(editor, retain);
}